<template>
  <section>
    <h1 class="fs-21 w-bold darks">Cambiar contraseña</h1>
    <p class="mb-4">
      Después de que hayas cambiado tu contraseña,
      serás redirigido a la página de login donde
      podrás ingresar con tu nueva contraseña.
    </p>

    <article
      v-if="statusMessage"
      class="c-card-alert p-3 mb-4"
      :class="`c-card-alert--${statusMessage.type}`"
    >
      {{statusMessage.text}}
    </article>

    <div class="row gy-5">
      <div class="col-12">
        <div class="c-form c-form--ghost">
          <div class="row gx-3 gy-3">
            <div class="col-12">
              <div
                class="c-form-group"
                :class="{'c-form-group--error' : $v.currentPassword.$error}"
              >
                <label class="w-sbold fs-14 mb-1">Contraseña actual</label>
                <input
                  v-model="$v.currentPassword.$model"
                  class="c-form__input d-block w-100 tiny"
                  type="password"
                />
                <span
                  v-if="!$v.currentPassword.required"
                  class="c-form__error"
                >
                  Debe ingresar su contraseña actual
                </span>
              </div>
            </div>
            <div class="col-12">
              <div
                class="c-form-group"
                :class="{'c-form-group--error' : $v.newPassword.$error}"
              >
                <label class="w-sbold fs-14 mb-1">Nueva contraseña</label>
                <input
                  v-model="$v.newPassword.$model"
                  class="c-form__input d-block w-100 tiny"
                  type="password"
                />
                <span
                  v-if="!$v.newPassword.required"
                  class="c-form__error"
                >
                  Debe ingresar la nueva contraseña
                </span>
                <span
                  v-else-if="!$v.newPassword.minLength"
                  class="c-form__error"
                >
                  La contraseña es muy corta (minimo 5 cáracteres)
                </span>
              </div>
            </div>
            <div class="col-12">
              <div
                class="c-form-group"
                :class="{'c-form-group--error' : $v.confirmedPassword.$error}"
              >
                <label class="w-sbold fs-14 mb-1">Confirma nueva contraseña</label>
                <input
                  v-model="$v.confirmedPassword.$model"
                  class="c-form__input d-block w-100 tiny"
                  type="password"
                />
                <span
                  v-if="!$v.confirmedPassword.required"
                  class="c-form__error"
                >
                  Debe ingresar la nueva contraseña
                </span>
                <span
                  v-else-if="!$v.confirmedPassword.isTheSame"
                  class="c-form__error"
                >
                  Las contraseñas no coinciden
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="d-flex justify-content-end align-items-center">
          <router-link
            to="/editar"
            class="c-link c-link--black d-flex align-items-center small"
          >
            <Icon icon="bi:arrow-left" class="fs-18 me-1" />
            Volver
          </router-link>
          <button
            @click="updatePassword()"
            class="c-button c-button--primary small ms-3"
            :class="{loading : isUpdating}"
            :disabled="isUpdating"
          >
            {{
              (isUpdating) ? 'Actualizando...' : 'Guardar contraseña'
            }}
            <img
              class="c-button__spinner"
              src="@/assets/images/animations/spinner-white.png"
              alt="loading"
            />
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { scroller } from 'vue-scrollto/src/scrollTo';
import {
  required,
  minLength,
} from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

import { clearSession } from '../../libs/auth';

export default {
  data() {
    return {
      scroll: scroller(),

      currentPassword: '',
      newPassword: '',
      confirmedPassword: '',

      isUpdating: false,
      statusMessage: null,
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),
  },
  validations: {
    currentPassword: {
      required,
    },
    newPassword: {
      required,
      minLength: minLength(5),
    },
    confirmedPassword: {
      required,
      isTheSame: function isTheSame() {
        return this.newPassword === this.confirmedPassword;
      },
    },
  },
  methods: {
    clearSession,

    updatePassword() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isUpdating = true;

        fetch(`${window.arcux.api}/users/${this.userData.id}/profile/password`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${window.arcux.token}`,
          },
          body: JSON.stringify({
            new_password: this.newPassword,
            current_password: this.currentPassword,
          }),
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((response) => {
            if (response.status) {
              this.statusMessage = {
                text: 'Datos actualizados exitosamente, cerrando sesión en breve...',
                type: 'success',
              };

              setTimeout(() => {
                this.clearSession(2);
              }, 2000);
            } else {
              this.statusMessage = {
                text: response.message,
                type: 'error',
              };

              this.isUpdating = false;
            }
          })
          .catch((error) => {
            this.isUpdating = false;

            let errorMessage = '';

            try {
              errorMessage = JSON.parse(error.message)?.message;
            } catch (err) {
              errorMessage = error.message;
            }

            this.statusMessage = {
              text: errorMessage,
              type: 'error',
            };
          })
          .finally(() => {
            this.scroll('#app');

            setTimeout(() => {
              this.statusMessage = null;
            }, 5000);
          });
      }
    },
  },
};
</script>
